import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'
import { pluralize } from 'humanize-plus'

import Avatar from 'shared-web/src/components/Avatar'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import * as PropertyActions from 'app/modules/user/properties/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PropertySelectors from 'app/modules/user/properties/selectors'

const humanizeRepAvatars = (repAvatars) => {
  switch (repAvatars.length) {
    case 0:
    case 1:
      return repAvatars
    case 2:
      return [repAvatars[0], <span>&nbsp;or&nbsp;</span>, repAvatars[1]]
    default:
      const remainingLength = repAvatars.length - 2
      return [repAvatars[0], <span>&nbsp;</span>, repAvatars[1], <span>{`\u00a0or ${remainingLength} ${pluralize(remainingLength, "other")}`}</span>]
  }
}

const RepAvatarPreview = ({
  listOfSelectedIds,
  usersWithExtension
}) => {
  const repAvatars = listOfSelectedIds.toJS().map((id) => {
    const user = usersWithExtension.get(id)
    const displayName = getDisplayName(user)
    return user && <div className="rep-preview" title={displayName}>
      <Avatar key={user.get('id')} user={user.toJS()} />
      <span>{displayName}</span>  
    </div>
  })
  return <div className="rep-preview">{humanizeRepAvatars(repAvatars)}</div>
}

const usersWithExtension = PropertySelectors.makeUsersWithProperty('extensionInstalled')

const mapStateToProps = state => ({
  usersWithExtension: usersWithExtension(state),
  isOutboundPlaybook: PlaybookSelectors.isOutboundPlaybook(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchUsersByPropertyName: PropertyActions.fetchUsersByPropertyName,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      if (this.props.isOutboundPlaybook) {
        this.props.actions.fetchUsersByPropertyName(['extensionInvited', 'extensionInstalled'])
      }
    },
  }),
)(RepAvatarPreview)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ConditionPreview/RepAvatarPreview.js